// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { memo, useCallback, useEffect, useState } from 'react'
import './SelectModePopUp.scss'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { PopUp, PrimaryButton, SecondaryButton } from 'ui_kit_qmd'
import { useDispatch } from 'react-redux'
import moment from 'moment'
import closeIcon from '../../../images/common/close.png'
import { editSchedule } from '../../../store/calendar/CalendarThunk'
import { getDaysOfWeekFromAbbreviationArr, getTabId } from '../../../utils/common'
import RadioButtonsGroup from '../../../components/radio-buttons-group/RadioButtonsGroup'
import { useSelector } from 'store/hooks/useSelector'

const SelectModePopUp = memo(
  ({
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setIsSelectModePopUp,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    clickedStartDateTime,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    clickedEndDateTime,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    occurrenceId,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    occurrenceOrder,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    scheduleId,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    viewType,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    recurrenceEndDateTime,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    daysOfWeekRef,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    visitTypeGroupId,
  }) => {
    const tabId = getTabId()

    const dispatch = useDispatch()
    const [selectedOption, setSelectedOption] = useState([
      { value: 'This event only', isChecked: true },
      { value: 'This and following events', isChecked: false },
    ])
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    const scheduleInfoFrom = useSelector((state) => state.calendarPageReducer.scheduleInfoFrom)
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    const scheduleInfoTo = useSelector((state) => state.calendarPageReducer.scheduleInfoTo)
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    const recurringBaseTimeZone = useSelector((state) => state.calendarPageReducer.recurringBaseTimeZone)

    const [selectedOptionValue, setSelectedOptionValue] = useState('This event only')

    useEffect(() => {
      if (selectedOption) {
        // @ts-expect-error TS2532 -- MIGRATION: not approved, fix when encountered
        setSelectedOptionValue(selectedOption.find((option) => option.isChecked).value)
      }
    }, [selectedOption])
    const fromDateTimeInCorrectFormat = moment(clickedStartDateTime.dateTime).format('YYYY-MM-DDTHH:mm:ss.SSSZ')
    const toDateTimeInCorrectFormat = moment(clickedEndDateTime.dateTime).format('YYYY-MM-DDTHH:mm:ss.SSSZ')

    const onPressSafeHandler = () => {
      const daysOfWeekList = getDaysOfWeekFromAbbreviationArr(daysOfWeekRef?.current?.getActiveDays())
      switch (selectedOptionValue) {
        case 'This event only':
          const editOccurrenceRequestBody = {
            TimeZone: recurringBaseTimeZone,
            Occurrences: {
              Edit: [
                {
                  VisitTypeGroupId: visitTypeGroupId,
                  ScheduleId: scheduleId,
                  OccurrenceId: occurrenceId,
                  FromDateTime: fromDateTimeInCorrectFormat,
                  ToDateTime: toDateTimeInCorrectFormat,
                  StateCodes: [],
                },
              ],
            },
          }
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          dispatch(editSchedule({ scheduleInfo: editOccurrenceRequestBody, tabId }))
          setIsSelectModePopUp(false)
          break
        case 'This and following events':
          if (occurrenceOrder === 0) {
            const requestEditFirstOccurrenceInScheduleBody = {
              TimeZone: recurringBaseTimeZone,
              Schedules: {
                Edit: [
                  {
                    ScheduleId: scheduleId,
                    VisitTypeGroupId: visitTypeGroupId,
                    FromDateTime: fromDateTimeInCorrectFormat,
                    ToDateTime: toDateTimeInCorrectFormat,
                    Type: viewType.includes('availability') ? 'availability' : 'unavailability',
                    StateCodes: [],
                    RecurringSettings: {
                      EndDateTime: recurrenceEndDateTime.dateTime,
                      WeekDays: daysOfWeekList,
                    },
                  },
                ],
              },
            }
            dispatch(
              editSchedule({
                scheduleInfo: requestEditFirstOccurrenceInScheduleBody,
                eventType: viewType.includes('availability') ? 'availability' : 'unavailability',
                tabId,
              }),
            )
          } else {
            const requestEditNonFirstOccurrenceInScheduleBody = {
              TimeZone: recurringBaseTimeZone,
              Schedules: {
                Create: [
                  {
                    VisitTypeGroupId: visitTypeGroupId,
                    FromDateTime: fromDateTimeInCorrectFormat,
                    ToDateTime: toDateTimeInCorrectFormat,
                    Type: viewType.includes('availability') ? 'availability' : 'unavailability',
                    RecurringSettings: {
                      EndDateTime: recurrenceEndDateTime.dateTime,
                      WeekDays: daysOfWeekList,
                    },
                  },
                ],
                Edit: [
                  {
                    VisitTypeGroupId: visitTypeGroupId,
                    ScheduleId: scheduleId,
                    FromDateTime: scheduleInfoFrom,
                    ToDateTime: scheduleInfoTo,
                    StateCodes: [],
                    RecurringSettings: {
                      EndDateTime: moment(clickedStartDateTime.dateTime)
                        .subtract(1, 'days')
                        .format('YYYY-MM-DDT00:mm:ss.SSSZ'),
                      WeekDays: daysOfWeekList,
                    },
                  },
                ],
              },
            }
            // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
            dispatch(editSchedule({ scheduleInfo: requestEditNonFirstOccurrenceInScheduleBody, tabId }))
          }
          setIsSelectModePopUp(false)
          break
        default:
          break
      }
    }

    const onCancelEditing = useCallback(() => {
      setIsSelectModePopUp(false)
    }, [setIsSelectModePopUp])
    return (
      <PopUp
        className='pop-up-additional'
        content={
          <div className='select-mode-container'>
            <div>
              <div className='select-mode-title'>Edit recurring event</div>
              <img
                role='presentation'
                alt='Close'
                src={closeIcon}
                className='select-mode-close-icon'
                onClick={onCancelEditing}
              />
              {/*
               // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered */}
              <RadioButtonsGroup setSelectedOption={setSelectedOption} optionsList={selectedOption} />
              <div className='select-mode-btn-mode'>
                <SecondaryButton
                  id='viewServiceCancelEditBtn'
                  btnText='Cancel'
                  className='secondary-btn-additional'
                  onPress={onCancelEditing}
                />
                <PrimaryButton
                  btnText='Save'
                  id='viewServiceSaveEditBtn'
                  className='primary-btn-additional'
                  onPress={onPressSafeHandler}
                />
              </div>
            </div>
          </div>
        }
      />
    )
  },
)

export default SelectModePopUp
